import React from "react";
import Icon from "../Icon";
import ExposedIcon from "../../../assets/icons/isExposedTrue.svg";
import NoExposedIcon from "../../../assets/icons/isExposedFalse.svg";
import FalsedIcon from "../../../assets/icons/IsFalseIcon.svg";

const StatusIcon: React.FC<{ isExposed?: boolean }> = function StatusIcon({
  isExposed,
}) {
  return isExposed === undefined ? (
    <Icon src={FalsedIcon} width="8px" height="8px" />
  ) : isExposed === true ? (
    <Icon src={ExposedIcon} width="8px" height="8px" />
  ) : (
    <Icon src={NoExposedIcon} width="8px" height="8px" />
  );
};
export default StatusIcon;
